<ng-template #thirdPortalSelection>
	<div class="p-4 panel-border">
		<h3 class="text-center my-1"
			data-testid="getStated">{{ 'onvio.setup.migrations.thirdPartyApps.migrateData' | translate }}</h3>
		<p class="text-center"
		   data-testid="thenComeHere">{{'onvio.setup.migrations.thirdPartyApps.thenComeHere' | translate}}
			<a href="{{ PREPARE_FOR_MIGRATION_LINK }}"
			   data-qe-id="migration-dashboard-third-party-applications-learn-more-link"
			   target="_blank"
			   rel="noopener noreferrer">
				{{'onvio.setup.migrations.learnMore' | translate}}
			</a>
		</p>
		<div class="text-center">
			<a class="btn btn-primary mt-3 wide-button"
			   href="https://cs.thomsonreuters.com/support/conversions/" target="_blank"
			   data-testid="goToAccountButton"
			   data-qe-id="migration-dashboard-third-party-applications-go-to-account-button">
				{{ 'onvio.setup.migrations.thirdPartyApps.goToAccount' | translate }}
			</a>
		</div>
	</div>
</ng-template>

<h1 class="learn-more-heading">{{'onvio.setup.migrations.thirdPartyApps.migrations' | translate }}</h1>

<app-inprogress
		showApplicationName="true"
		[migrationSource]="migrationSource"
		[customTemplate]="thirdPortalSelection">
</app-inprogress>

<app-completed
        showApplicationNameColumn="true"
        [migrationSource]="migrationSource"
		[showClientRegistrationLink]="false">
</app-completed>
